// extracted by mini-css-extract-plugin
export default {"kalu_Container":"Kalu_kalu_Container__6fyQE","kalu_Wrapper":"Kalu_kalu_Wrapper__djbUV","kalu_Link":"Kalu_kalu_Link__qGa9z"};